var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"page-container tw-bg-[#f8f8f8] tw-flex tw-flex-grow tw-relative tw-px-4 xl:tw-pt-[3.5rem] xl:tw-pt-[40px] xl:tw-px-52",attrs:{"role":"main"}},[_c('div',{staticClass:"tw-w-full xl:tw-container xl:tw-mx-auto"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }